import { Button as BaseButton, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** Marketing actions, kept separate from existing article markup and tool controls. */
export function Button({ className, ...props }: ButtonProps) {
  return <BaseButton {...props} className={cn("h-auto min-h-12 whitespace-normal rounded-xl px-6 py-3.5 text-sm font-semibold", className)} />;
}
